<template>
  <div class="c-app flex-row align-items-center amsys-header">
    <CWrapper>
      <CHeader fixed with-subheader light style="position: fixed;">
        <CToggler
          in-header
          class="ml-3 d-lg-none"
          @click="$store.commit('toggleSidebarMobile')"
        />
        <CToggler
          in-header
          class="ml-3 d-md-down-none"
          @click="$store.commit('toggleSidebarDesktop')"
        />
        <CHeaderBrand class="d-lg-none">
          <h3>
            <b>
              <font color="Green">COAL</font>
              <font color="gray">PRODUCTION</font></b
            >
          </h3>
        </CHeaderBrand>
        <CHeaderNav class="d-md-down-none mr-auto">
          <CHeaderNavItem class="px-3">
            <h3>
              <b>
                <font color="Green">COAL</font>
                <font color="gray">PRODUCTION</font></b
              >
            </h3>
          </CHeaderNavItem>
        </CHeaderNav>
      </CHeader>
      <div class="c-body">
        <main class="c-main">
          <CRow>
            <CCol class="amsys-dashboard-parameter2">
              <select
                class="form-control"
                style="font-weight: bold; font-size:18px;"
                @change="reloadData()"
                v-model="selectedData"
              >
                <option value="ALL">
                  ---
                </option>
                <option
                  v-for="item in companyResult"
                  :value="item.Company"
                  :key="item.Code"
                >
                  {{ item.Code }}
                </option>
              </select>
            </CCol>
          </CRow>
          <CRow>
            <CCol class="amsys-dashboard-parameter2">
              <div style="font-size:14px; text-align:left;">
                <h5>
                  <b>
                    <font color="black"
                      >Tanggal Transaksi :
                      {{ this.transDate.split("T")[0] }}</font
                    ></b
                  >
                </h5>
              </div>
            </CCol>
          </CRow>
          <CRow>
            <CCol class="amsys-dashboard-parameter2">
              <div style="font-size:14px; text-align:left;">
                <h5>
                  <b>
                    <font color="black">Shift : {{ this.shiftName }}</font></b
                  >
                </h5>
              </div>
            </CCol>
          </CRow>
          <br />
          <CRow class="amsys-dashboard-row">
            <CCol class="amsys-dashboard-frame">
              <div class="card">
                <div class="card-header" style="background-color:Green;">
                  <h5>
                    <b> <font color="white">DAILY PRODUCTION</font></b>
                  </h5>
                </div>
                <div class="card-body">
                  <CRow>
                    <CCol
                      class="amsys-dashboard-parameter2"
                      @click="getDataFleet(1)"
                    >
                      <div style="font-size:14px; text-align:center;">
                        <h5>
                          <b>
                            <font color="black">{{ this.FleetOB }}</font></b
                          >
                        </h5>
                      </div>
                    </CCol>
                    <CCol
                      class="amsys-dashboard-parameter2"
                      @click="getDataFleet(0)"
                    >
                      <div style="font-size:14px;text-align:center;">
                        <h5>
                          <b>
                            <font color="black">{{ this.FleetCG }}</font></b
                          >
                        </h5>
                      </div>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol
                      class="amsys-dashboard-parameter2"
                      @click="getDataFleet(1)"
                    >
                      <div
                        style="font-weight: bold; font-size:13px; text-align:center;"
                      >
                        <h7
                          ><b>
                            <font color="black">FLEET OVER BURDEN</font></b
                          ></h7
                        >
                      </div>
                    </CCol>
                    <CCol
                      class="amsys-dashboard-parameter2"
                      @click="getDataFleet(0)"
                    >
                      <div
                        style="font-weight: bold; font-size:13px;text-align:center;"
                      >
                        <h7
                          ><b>
                            <font color="black">FLEET COAL GETTING</font></b
                          ></h7
                        >
                      </div>
                    </CCol>
                  </CRow>
                  <div class="amsys-dashboard-gauge">
                    <DxCircularGauge id="gauge" :value="this.Persen">
                      <DxScale
                        :start-value="0"
                        :end-value="100"
                        :tick-interval="10"
                      >
                        <DxLabel :customize-text="customizeText" />
                      </DxScale>
                      <DxRangeContainer>
                        <DxRange
                          :start-value="0"
                          :end-value="20"
                          color="#CE2029"
                        />
                        <DxRange
                          :start-value="20"
                          :end-value="50"
                          color="#FFD700"
                        />
                        <DxRange
                          :start-value="50"
                          :end-value="100"
                          color="#228B22"
                        />
                      </DxRangeContainer>
                      <DxExport :enabled="false" />
                    </DxCircularGauge>
                  </div>
                  <CRow>
                    <CCol class="amsys-dashboard-parameter">
                      <div style="font-size:14px; text-align:center;">
                        <h5>
                          <b>
                            <font color="black"
                              >{{
                                this.Persen.toFixed(2)
                                  .toString()
                                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                              }}
                              %</font
                            ></b
                          >
                        </h5>
                      </div>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol class="amsys-dashboard-parameter">
                      <div
                        style="font-weight: bold; font-size:14px; text-align:center;"
                      >
                        <h5>
                          <b> <font color="black">OB REMOVAL</font></b>
                        </h5>
                      </div>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol class="amsys-dashboard-parameter2">
                      <div style="font-size:14px; text-align:center;">
                        <h5>
                          <b>
                            <font color="black">{{
                              this.Bcm.toFixed(2)
                                .toString()
                                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                            }}</font></b
                          >
                        </h5>
                      </div>
                    </CCol>
                    <CCol class="amsys-dashboard-parameter2">
                      <div style="font-size:14px;text-align:center;">
                        <h5>
                          <b>
                            <font color="black">{{
                              this.BcmPlan.toFixed(2)
                                .toString()
                                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                            }}</font></b
                          >
                        </h5>
                      </div>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol class="amsys-dashboard-parameter2">
                      <div
                        style="font-weight: bold; font-size:14px; text-align:center;"
                      >
                        <h5>
                          <b> <font color="black">ACTUAL</font></b>
                        </h5>
                      </div>
                    </CCol>
                    <CCol class="amsys-dashboard-parameter2">
                      <div
                        style="font-weight: bold; font-size:14px;text-align:center;"
                      >
                        <h5>
                          <b> <font color="black">PLAN</font></b>
                        </h5>
                      </div>
                    </CCol>
                  </CRow>

                  <div class="amsys-dashboard-gauge">
                    <DxCircularGauge id="gauge" :value="this.CoalPersen">
                      <DxScale
                        :start-value="0"
                        :end-value="100"
                        :tick-interval="10"
                      >
                        <DxLabel :customize-text="customizeText" />
                      </DxScale>
                      <DxRangeContainer>
                        <DxRange
                          :start-value="0"
                          :end-value="20"
                          color="#CE2029"
                        />
                        <DxRange
                          :start-value="20"
                          :end-value="50"
                          color="#FFD700"
                        />
                        <DxRange
                          :start-value="50"
                          :end-value="100"
                          color="#228B22"
                        />
                      </DxRangeContainer>
                      <DxExport :enabled="false" />
                    </DxCircularGauge>
                  </div>
                  <CRow>
                    <CCol class="amsys-dashboard-parameter">
                      <div style="font-size:14px; text-align:center;">
                        <h5>
                          <b>
                            <font color="black"
                              >{{
                                this.CoalPersen.toFixed(2)
                                  .toString()
                                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                              }}
                              %</font
                            ></b
                          >
                        </h5>
                      </div>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol class="amsys-dashboard-parameter">
                      <div
                        style="font-weight: bold; font-size:14px; text-align:center;"
                      >
                        <h5>
                          <b> <font color="black">COAL GETTING</font></b>
                        </h5>
                      </div>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol class="amsys-dashboard-parameter2">
                      <div style="font-size:14px; text-align:center;">
                        <h5>
                          <b>
                            <font color="black">{{
                              this.Mt.toFixed(2)
                                .toString()
                                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                            }}</font></b
                          >
                        </h5>
                      </div>
                    </CCol>
                    <CCol class="amsys-dashboard-parameter2">
                      <div style="font-size:14px;text-align:center;">
                        <h5>
                          <b>
                            <font color="black">{{
                              this.MtPlan.toFixed(2)
                                .toString()
                                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                            }}</font></b
                          >
                        </h5>
                      </div>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol class="amsys-dashboard-parameter2">
                      <div
                        style="font-weight: bold; font-size:14px; text-align:center;"
                      >
                        <h5>
                          <b> <font color="black">ACTUAL</font></b>
                        </h5>
                      </div>
                    </CCol>
                    <CCol class="amsys-dashboard-parameter2">
                      <div
                        style="font-weight: bold; font-size:14px;text-align:center;"
                      >
                        <h5>
                          <b> <font color="black">PLAN</font></b>
                        </h5>
                      </div>
                    </CCol>
                  </CRow>
                </div>
              </div>
              <br /><br />
              <div class="card">
                <div class="card-header" style="background-color:Green;">
                  <h5>
                    <b> <font color="white">MONTHLY PRODUCTION</font></b>
                  </h5>
                </div>
                <div class="card-body">
                  <div class="amsys-dashboard-gauge">
                    <DxCircularGauge id="gauge" :value="this.MtdBcmPersen">
                      <DxScale
                        :start-value="0"
                        :end-value="100"
                        :tick-interval="10"
                      >
                        <DxLabel :customize-text="customizeText" />
                      </DxScale>
                      <DxRangeContainer>
                        <DxRange
                          :start-value="0"
                          :end-value="20"
                          color="#CE2029"
                        />
                        <DxRange
                          :start-value="20"
                          :end-value="50"
                          color="#FFD700"
                        />
                        <DxRange
                          :start-value="50"
                          :end-value="100"
                          color="#228B22"
                        />
                      </DxRangeContainer>
                      <DxExport :enabled="false" />
                    </DxCircularGauge>
                  </div>
                  <CRow>
                    <CCol class="amsys-dashboard-parameter">
                      <div style="font-size:14px; text-align:center;">
                        <h5>
                          <b>
                            <font color="black"
                              >{{
                                this.MtdBcmPersen.toFixed(2)
                                  .toString()
                                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                              }}
                              %</font
                            ></b
                          >
                        </h5>
                      </div>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol class="amsys-dashboard-parameter">
                      <div
                        style="font-weight: bold; font-size:14px; text-align:center;"
                      >
                        <h5>
                          <b> <font color="black">OB REMOVAL</font></b>
                        </h5>
                      </div>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol class="amsys-dashboard-parameter2">
                      <div style="font-size:14px; text-align:center;">
                        <h5>
                          <b>
                            <font color="black">{{
                              this.MtdBcm.toFixed(2)
                                .toString()
                                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                            }}</font></b
                          >
                        </h5>
                      </div>
                    </CCol>
                    <CCol class="amsys-dashboard-parameter2">
                      <div style="font-size:14px;text-align:center;">
                        <h5>
                          <b>
                            <font color="black">{{
                              this.MtdBcmPlan.toFixed(2)
                                .toString()
                                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                            }}</font></b
                          >
                        </h5>
                      </div>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol class="amsys-dashboard-parameter2">
                      <div
                        style="font-weight: bold; font-size:14px; text-align:center;"
                      >
                        <h5>
                          <b> <font color="black">ACTUAL</font></b>
                        </h5>
                      </div>
                    </CCol>
                    <CCol class="amsys-dashboard-parameter2">
                      <div
                        style="font-weight: bold; font-size:14px;text-align:center;"
                      >
                        <h5>
                          <b> <font color="black">PLAN</font></b>
                        </h5>
                      </div>
                    </CCol>
                  </CRow>

                  <div class="amsys-dashboard-gauge">
                    <DxCircularGauge id="gauge" :value="this.MtdPersen">
                      <DxScale
                        :start-value="0"
                        :end-value="100"
                        :tick-interval="10"
                      >
                        <DxLabel :customize-text="customizeText" />
                      </DxScale>
                      <DxRangeContainer>
                        <DxRange
                          :start-value="0"
                          :end-value="20"
                          color="#CE2029"
                        />
                        <DxRange
                          :start-value="20"
                          :end-value="50"
                          color="#FFD700"
                        />
                        <DxRange
                          :start-value="50"
                          :end-value="100"
                          color="#228B22"
                        />
                      </DxRangeContainer>
                      <DxExport :enabled="false" />
                    </DxCircularGauge>
                  </div>
                  <CRow>
                    <CCol class="amsys-dashboard-parameter">
                      <div style="font-size:14px; text-align:center;">
                        <h5>
                          <b>
                            <font color="black"
                              >{{
                                this.MtdPersen.toFixed(2)
                                  .toString()
                                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                              }}
                              %</font
                            ></b
                          >
                        </h5>
                      </div>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol class="amsys-dashboard-parameter">
                      <div
                        style="font-weight: bold; font-size:14px; text-align:center;"
                      >
                        <h5>
                          <b> <font color="black">COAL GETTING</font></b>
                        </h5>
                      </div>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol class="amsys-dashboard-parameter2">
                      <div style="font-size:14px; text-align:center;">
                        <h5>
                          <b>
                            <font color="black">{{
                              this.MtdMt.toFixed(2)
                                .toString()
                                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                            }}</font></b
                          >
                        </h5>
                      </div>
                    </CCol>
                    <CCol class="amsys-dashboard-parameter2">
                      <div style="font-size:14px;text-align:center;">
                        <h5>
                          <b>
                            <font color="black">{{
                              this.MtdMtPlan.toFixed(2)
                                .toString()
                                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                            }}</font></b
                          >
                        </h5>
                      </div>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol class="amsys-dashboard-parameter2">
                      <div
                        style="font-weight: bold; font-size:14px; text-align:center;"
                      >
                        <h5>
                          <b> <font color="black">ACTUAL</font></b>
                        </h5>
                      </div>
                    </CCol>
                    <CCol class="amsys-dashboard-parameter2">
                      <div
                        style="font-weight: bold; font-size:14px;text-align:center;"
                      >
                        <h5>
                          <b> <font color="black">PLAN</font></b>
                        </h5>
                      </div>
                    </CCol>
                  </CRow>
                </div>
              </div>
            </CCol>
          </CRow>
        </main>
      </div>
    </CWrapper>
    <CModal
      size="xl"
      :show.sync="modalFleet"
      :centered="true"
      color="info"
      style="font-size: 12px;"
    >
      <div style="text-align:center;">
        <font style="font-size:13px; width: 100%;"
          ><b>DETAIL DASHBOARD</b></font
        >
      </div>
      <br />
      <font style="font-size:12px; width: 80%;"
        ><b>{{ this.clock }}</b></font
      >
      <br />
      <font style="font-size:12px; width: 80%;"
        ><b>{{ this.Fleet }} {{ this.TypeFleet }} FLEET</b></font
      >
      <br />
      <br />
      <div>
        <table class="table" style="border: 0;">
          <tr>
            <td class="amsys-det-app-td1">Shift</td>
            <td class="amsys-det-app-td1">Digger</td>
            <td class="amsys-det-app-td1">Hauler Total</td>
            <td class="amsys-det-app-td1">Hauler Code</td>
            <td class="amsys-det-app-td1">Activity</td>
          </tr>
          <tbody>
            <tr v-for="item in details">
              <td>{{ item.Shift }}</td>
              <td>{{ item.DiggerCode }}</td>
              <td>
                {{
                  item.HaulerTotal.toFixed(2)
                    .toString()
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                }}
              </td>
              <td>{{ item.HaulerDetail }}</td>
              <td>{{ item.Activity }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <template #footer>
        <CButton @click="modalFleet = false" color="secondary">Close</CButton>
      </template>
    </CModal>
  </div>
</template>
<script>
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import Vue from "vue";
import axios from "axios";
import "@babel/polyfill";
import VueCordova from "vue-cordova";
import { DxPieChart, DxConnector } from "devextreme-vue/pie-chart";
import {
  DxSeries,
  DxLegend,
  DxLabel,
  DxFont,
  DxExport,
  DxTooltip,
  DxChart,
  DxCommonSeriesSettings,
  DxArgumentAxis,
  DxGrid,
  DxCrosshair,
  DxPoint,
  DxTitle,
  DxSubtitle,
  DxValueAxis,
} from "devextreme-vue/chart";
import {
  DxCircularGauge,
  DxScale,
  DxRangeContainer,
  DxRange,
} from "devextreme-vue/circular-gauge";
import CryptoJS from "crypto-js";

Vue.use(VueCordova);
export default {
  components: {
    DxChart,
    DxCommonSeriesSettings,
    DxSeries,
    DxArgumentAxis,
    DxGrid,
    DxCrosshair,
    DxExport,
    DxLegend,
    DxPoint,
    DxLabel,
    DxFont,
    DxTitle,
    DxSubtitle,
    DxTooltip,
    DxValueAxis,
    DxPieChart,
    DxConnector,
    DxCircularGauge,
    DxScale,
    DxRangeContainer,
    DxRange,
  },

  data() {
    return {
      selectedYear: new Date().getFullYear(),
      companyResult: [],
      rkabResult: [],
      details: [],
      selectedData: "ALL",
      dataSource: [],
      data: [],
      company: [],
      company1: [],
      company2: [],
      company3: [],
      show: true,
      modalFleet: false,
      shiftName: "",
      transDate: "",
      Bcm: 0,
      BcmPlan: 0,
      Persen: 0,
      Mt: 0,
      MtPlan: 0,
      CoalPersen: 0,
      FleetCG: 0,
      FleetOB: 0,
      MtdMt: 0,
      MtdMtPlan: 0,
      MtdPersen: 0,
      MtdBcm: 0,
      MtdBcmPlan: 0,
      MtdBcmPersen: 0,
      clock: "",
      TypeFleet: "",
      Fleet: 0,

      urlServer: "",
    };
  },
  methods: {
    getDataFleet(fleet) {
      let data = localStorage.token;

      if (fleet == 1) {
        this.TypeFleet = "OB";
        this.Fleet = this.FleetOB;
      } else {
        this.TypeFleet = "CG";
        this.Fleet = this.FleetCG;
      }
      this.modalFleet = true;
      //const param = { "Company": this.selectedData, "TransDate": this.transDate };
      const param = {
        Company: this.selectedData,
        Service: fleet,
        TransDate: this.transDate,
      };
      if (this.selectedData != "ALL") {
        this.details = new Array();
        if (typeof data != "undefined") {
          axios
            .post(
              `${this.urlServer}/Api/Production/GetProductionCurrentFleetDetail/`,
              param,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + data,
                },
              }
            )
            .then((res) => {
              console.log(res.data);
              if (res.data.length == 0) {
                this.details = new Array();
              } else {
                this.details = res.data;
              }
            })
            .catch((error) => {
              this.loading = false;
              console.error(error);
            });
        } else {
          this.loading = false;
          this.$router.push({ path: "/logout" });
        }
      } else {
      }
      this.loading = false;
    },
    start() {
      console.log(localStorage.token);
      let data = localStorage.token;
      if (typeof data == "undefined") {
        this.$router.push({ path: "/logout" });
      } else {
        this.loading = true;
        axios
          .get(`${this.urlServer}/Api/General/GetCurrentShift/`, {
            headers: {
              Authorization: "Bearer " + data,
            },
          })
          .then((res) => {
            this.shiftName = res.data[0].ShiftName;
            this.transDate = res.data[0].TransDate;
            console.log(res.data[0]);
          });

        axios
          .get(`${this.urlServer}/Api/Production/GetClockRangeLabel/`, {
            headers: {
              Authorization: "Bearer " + data,
            },
          })
          .then((res) => {
            this.clock = res.data;
          });
      }
    },
    formatLabel(pointInfo) {
      return `${pointInfo.percentText}`;
    },
    customizeTooltip(pointInfo) {
      return {
        text: `${pointInfo.value
          .toFixed(2)
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")} MT`,
      };
    },
    customizeTooltipOB(pointInfo) {
      return {
        text: `${pointInfo.value
          .toFixed(2)
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")} Bcm`,
      };
    },
    customizeTooltipSR(pointInfo) {
      return {
        text: `${pointInfo.value
          .toFixed(2)
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`,
      };
    },
    customizeText({ valueText }) {
      return `${valueText}`;
      //return `Rp. ${valueText.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} MT`;
    },
    reloadData() {
      let data = localStorage.token;
      console.log(this.selectedData);
      const param = { Company: this.selectedData, TransDate: this.transDate };
      //const param = { "Company": this.selectedData, "TransDate": '2022-03-14' };
      //const param = { "Company": this.selectedData, "TransDate": '2022-02-26' };
      if (this.selectedData != "ALL") {
        this.data = new Array();

        if (typeof data != "undefined") {
          const cp = new Array();
          var mon = "";

          axios
            .post(
              `${this.urlServer}/Api/Production/GetProductionDailyOB/`,
              param,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + data,
                },
              }
            )
            .then((res) => {
              console.log(res);
              if (res.data.length == 0) {
                this.Bcm = 0;
                this.BcmPlan = 0;
                this.Persen = 0;
              } else {
                var data1 = res.data[0];
                this.Bcm = data1.Bcm;
                this.BcmPlan = data1.BcmPlan;
                this.Persen = data1.Persen;
              }
            })
            .catch((error) => {
              this.loading = false;
              console.error(error);
            });

          axios
            .post(
              `${this.urlServer}/Api/Production/GetProductionDailyCG/`,
              param,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + data,
                },
              }
            )
            .then((res) => {
              console.log(res);
              if (res.data.length == 0) {
                this.Mt = 0;
                this.MtPlan = 0;
                this.CoalPersen = 0;
              } else {
                var data1 = res.data[0];
                this.Mt = data1.Mt;
                this.MtPlan = data1.MtPlan;
                this.CoalPersen = data1.Persen;
              }
            })
            .catch((error) => {
              this.loading = false;
              console.error(error);
            });

          axios
            .post(
              `${this.urlServer}/Api/Production/GetProductionCurrentFleet/`,
              param,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + data,
                },
              }
            )
            .then((res) => {
              console.log(res);
              var data1 = res.data;
              if (data1.length != 0) {
                for (let i = 0; i < data1.length; i++) {
                  if (data1[i].Note == "Fleet Over Burden") {
                    this.FleetOB = data1[i].Total;
                  } else {
                    this.FleetCG = data1[i].Total;
                  }
                }
              } else {
                this.FleetOB = 0;
                this.FleetCG = 0;
              }
            })
            .catch((error) => {
              this.loading = false;
              console.error(error);
            });

          axios
            .post(
              `${this.urlServer}/Api/Production/GetProductionMonthlyOB/`,
              param,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + data,
                },
              }
            )
            .then((res) => {
              console.log(res);
              var data1 = res.data;
              if (data1.length != 0) {
                this.MtdBcm = data1[0].MtdBcm;
                this.MtdBcmPlan = data1[0].MtdBcmPlan;
                this.MtdBcmPersen = data1[0].Persen;
              } else {
                this.MtdBcm = 0;
                this.MtdBcmPlan = 0;
                this.MtdBcmPersen = 0;
              }
            })
            .catch((error) => {
              this.loading = false;
              console.error(error);
            });

          axios
            .post(
              `${this.urlServer}/Api/Production/GetProductionMonthlyCG/`,
              param,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + data,
                },
              }
            )
            .then((res) => {
              console.log(res);
              var data2 = res.data;
              if (data2.length != 0) {
                this.MtdMt = data2[0].MtdMt;
                this.MtdMtPlan = data2[0].MtdMtPlan;
                this.MtdPersen = data2[0].Persen;
              } else {
                this.MtdMt = 0;
                this.MtdMtPlan = 0;
                this.MtdPersen = 0;
              }
            })
            .catch((error) => {
              this.loading = false;
              console.error(error);
            });
        } else {
          this.loading = false;
          this.$router.push({ path: "/logout" });
        }
      } else {
      }
      this.loading = false;
    },
  },
  beforeMount() {
    this.loading = true;
    const stringToProtect = "Amsys_2@2021";
    let url = CryptoJS.AES.decrypt(localStorage.url, stringToProtect);
    const urlS = url.toString(CryptoJS.enc.Utf8);
    this.urlServer = urlS;
    let data = localStorage.token;
    const param = { Company: "PT. CAKRAWALA DINAMIKA ENERGI", Year: "2019" };

    const form = new FormData();
    form.append("CompanyOid", this.selectedData);
    let sendData = JSON.stringify(Object.fromEntries(form));
    if (typeof data != "undefined") {
      axios
        .post(`${urlS}/Api/General/GetCompany/`, sendData, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          console.log(res);
          this.companyResult = res.data;
        })
        .catch((error) => {
          let err = error.toString();
          if (err.toString().match(/^.*undefined.*$/)) {
            Vue.$toast.open({
              message: "Sorry, Your token has expired!",
              type: "warning",
              position: "bottom",
            });
            this.$router.push({ path: "/logout" });
          } else {
            Vue.$toast.open({
              message: error,
              type: "error",
              position: "bottom",
            });
          }
        });
    } else {
      this.$router.push({ path: "/logout" });
    }
    this.start();
    this.reloadData();
    this.loading = false;
  },
};
</script>
<style scoped>
#gauge {
  height: 440px;
  width: 100%;
}
</style>
